import { motion } from 'framer-motion'
import StatBadge     from '../ui/StatBadge'
import { BalloonLayer } from '../ui/BalloonSVG'

const STATS = [
  { number: '99+',  label: 'Successful Parties'  },
  { number: '100%', label: 'Client Satisfaction'  },
  { number: '3',    label: 'Package Options'       },
]

const itemVariants = {
  hidden: { opacity: 0, y: 24 },
  show:   { opacity: 1, y: 0, transition: { duration: 0.6, ease: 'easeOut' } },
}

export default function PackagesHero() {
  return (
    <section
      className="relative pt-32 pb-24 overflow-hidden"
      style={{ background: 'linear-gradient(135deg, #FF6BB5 0%, #7C3AFF 100%)' }}
    >
      {/* Decorative orbs */}
      <div className="absolute top-1/4 left-1/3 w-80 h-80 bg-white/10 rounded-full blur-3xl pointer-events-none" />
      <div className="absolute bottom-0 right-1/4 w-64 h-64 bg-white/10 rounded-full blur-3xl pointer-events-none" />
      <BalloonLayer opacity={0.30} />

      <div className="container-custom relative z-10 text-center">
        <motion.p
          variants={itemVariants}
          initial="hidden"
          animate="show"
          className="inline-flex items-center gap-2 mb-5 px-5 py-2 rounded-full bg-white/20 border border-white/30 text-white text-sm font-body font-bold tracking-widest uppercase backdrop-blur-sm"
        >
          🎁 Birthday Packages
        </motion.p>

        <motion.h1
          variants={itemVariants}
          initial="hidden"
          animate="show"
          transition={{ delay: 0.1 }}
          className="font-display text-5xl md:text-6xl text-white mb-6"
        >
          Choose Your Perfect Package
        </motion.h1>

        <motion.p
          variants={itemVariants}
          initial="hidden"
          animate="show"
          transition={{ delay: 0.2 }}
          className="font-body text-white/80 text-lg max-w-xl mx-auto mb-14"
        >
          From small birthdays to grand celebrations — we have it all
        </motion.p>

        {/* Stat badges */}
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.35, duration: 0.6 }}
          className="flex flex-wrap justify-center gap-4"
        >
          {STATS.map(({ number, label }) => (
            <div
              key={label}
              className="bg-white rounded-3xl px-8 py-5 shadow-glow-primary min-w-[140px]"
            >
              <StatBadge number={number} label={label} animate={false} />
            </div>
          ))}
        </motion.div>
      </div>
    </section>
  )
}
